import moment from "moment";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const defaultRender = (value) => (value ? value : "0.00");
const useTransactionCell = () => {
    const { t } = useTranslation();
    const offsetToMinutes = (offset) => {
        const [hours, minutes, seconds] = offset.split(":").map(Number);
        return hours * 60 + minutes + Math.sign(hours) * (seconds > 0 ? 1 : 0);
    };
    const formatAmount = (value) => {
        if (isNaN(value)) return "0.00";
        return Number(value).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };
    const { UserCompleteDetails } = useSelector(state => state.user);
    const formatDateTime = (serverDateTime) => {
        if (!serverDateTime) return "--";

        const serverTime = moment.parseZone(serverDateTime);
        const serverOffsetMin = offsetToMinutes(UserCompleteDetails?.serverGMTOffset || "00:00:00");
        const clientOffsetMin = offsetToMinutes(UserCompleteDetails?.gmtOffset || "00:00:00");
        const diffOffset = clientOffsetMin - serverOffsetMin;

        return serverTime.add(diffOffset, "minutes").format("DD-MM-YYYY HH:mm:ss");
    };
    return [
        { title: t("time"), dataIndex: 'dateTime', render: (value) => formatDateTime(value), },
        { title: t("id"), dataIndex: 'ticket', render: defaultRender, },
        { title: t('amount'), dataIndex: 'amount', render: (value) => formatAmount(value), },
        {
            title: t('transactionType'), dataIndex: 'type', render: (value) => {
                const typeMap = {
                    1: "Deposit",
                    2: "Adjustment",
                    3: "Credit In",
                    4: "Withdrawal",
                    5: "Credit Out",
                };
                return typeMap[value] || "Unknown";
            },
        },
        { title: t("comment"), width: 100, dataIndex: "comment", render: defaultRender },

    ];
};

export default useTransactionCell;
